import { useTranslation } from "react-i18next";
import { Modal } from "../../common";
import { Button } from "../../App.styles";

const VideoLengthModal = ({ onDismiss, show }) => {
  const { t } = useTranslation();

  return (
    <Modal onDismiss={onDismiss} show={show}>
      <div className="modal-header">
        <h4 className="modal-title">{t('Video Length')}</h4>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-hidden="true"
          onClick={onDismiss}
        >
          ×
        </button>
      </div>
      <div className="modal-body">
        <p>{t('Video challenges can be limited by duration.')}</p>
        <ul>
          <li>
            {t(`Shorter videos upload faster and so get stuck on a player's device
            less often.`)}
          </li>
          <li>{t('Consider the sharing format when configuring video length.')}</li>
          <li>
            {t(`We recommend 30s for standard videos, 5s for animated gifs and 10s for
            audio only.`)}
          </li>
        </ul>
      </div>
      <div className="modal-footer">
        <Button type="button" color="dark" data-dismiss="modal" onClick={onDismiss}>
          {t('Close')}
        </Button>
      </div>
    </Modal>
  )
};

export default VideoLengthModal;
